module.exports = __webpack_public_path__ + "static/media/hardware.ba1dd348.jpg";